import { cn } from "@/lib/utils";
import { format } from "date-fns";

interface CommentBubbleProps {
  content: string;
  timestamp?: Date | string;
  isOwn?: boolean;
  className?: string;
}

export function CommentBubble({
  content,
  timestamp,
  isOwn = true,
  className,
}: CommentBubbleProps) {
  const formattedTime = timestamp
    ? format(new Date(timestamp), "h:mm a")
    : undefined;

  return (
    <div
      className={cn(
        "flex flex-col",
        isOwn ? "items-end" : "items-start",
        className
      )}
    >
      <div
        className={cn(
          "max-w-[280px] rounded-2xl px-4 py-2 text-sm",
          isOwn
            ? "rounded-br-sm bg-blue-500 text-white"
            : "rounded-bl-sm bg-gray-100 text-gray-900"
        )}
      >
        {content}
      </div>
      {formattedTime && (
        <span className="mt-1 text-xs text-gray-500">{formattedTime}</span>
      )}
    </div>
  );
}
